function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#E74C3C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.807 6.539l-1.976 1.976-1.729-.617-.617-1.73 1.976-1.975a3.723 3.723 0 00-4.737 4.642 1.751 1.751 0 00-.156.137L4.51 13.031a1.74 1.74 0 102.46 2.46l4.059-4.06c.05-.049.095-.1.137-.155a3.722 3.722 0 004.642-4.737z",
  fill: "#FFF"
}))));